/** Timeout for AI-forslag til målretting (dokument/URL + OpenAI). */
const FORM_AI_SUGGEST_TIMEOUT_MS = 1000 * 120;

export const TIMEOUTS = {
	formAiSuggestTimeoutMs: FORM_AI_SUGGEST_TIMEOUT_MS,
};
